import moment from 'moment-timezone';
import { api, signalr } from '@/f1/service'
import FolderSet from '../FolderSet.i18n';
import Item from '../Item';
import { saveAs } from 'file-saver/FileSaver';
import forge from 'node-forge';
// import codes from '@/f1/codes';

import agent from '../service'
import WhitePath from '../WhitePath';
import AgentList from '../Agent.List.i18n';
import _ from 'lodash';
import { VclFacebook } from 'vue-content-loading';
import SettingQuickSetup from '../Rule.Quick.Setup.i18n'
// import VueSpeedometer from "vue-speedometer"
import Language from './language'
import { Switch as cSwitch } from '@coreui/vue'
import VueApexCharts from 'vue-apexcharts'
import ResultDetail from '../../result/Result.Detail.i18n'
import Bell from 'vue-notification-bell'
import config from '../../../../config';
import codes from '../../../../codes'
import Schedule from '../Schedule.i18n'

const _i18n_data = {
  saved: {
    EN : `saved`,
    KO : `저장되었습니다`,
  },
  updated: {
    EN : `updated`,
    KO : `업데이트되었습니다`,
  },
  copid: {
    EN : `copid`,
    KO : `복사되었습니다`,
  },
  removed: {
    EN : `removed`,
    KO : `삭제되었습니다`,
  },
  start: {
    EN : `request start`,
    KO : `점검을 요청하였습니다`,
  },
  stop: {
    EN : `request stop`,
    KO : `중지를 요청하였습니다`,
  },
  stopped : {
    EN : `agent stopped`,
    KO : `중지되었습니다`,
  },
  findout : {
    EN : `find out Webshell`,
    KO : `웹쉘이 탐지 되었습니다`,
  },
  upgrade : {
    EN : `request agent upgrade`,
    KO : `업그레이드를 요청하였습니다`,
  },
  restore : {
    EN : `file was recovered`,
    KO : `파일이 원복되었습니다`,
  },
  backup : {
    EN : `file was isolation`,
    KO : `파일이 격리되었습니다`,
  },
  remove : {
    EN : `file was removed`,
    KO : `파일이 삭제되었습니다`,
  },
};

// let h_opt = [
//     { text : 'every day', value : 9 },
//     { text : 'Sun', value : 0 },
//     { text : 'Mon', value : 1 },
//     { text : 'Tue', value : 2 },
//     { text : 'Wed', value : 3 },
//     { text : 'Thu', value : 4 },
//     { text : 'Fri', value : 5 },
//     { text : 'Sat', value : 6 },
// ]
// chart is { series : [ { name : '', data : [] } ] }
const default_model = () => ({
  chart : {
    color : {
      NORMAL : '#339BFB',
      WARNING : '#FFC90E',
      DANGER : '#F44336',
    },
    memory : { colors:['#339BFB' ], title : { text: 'Memory (%)', align : 'left'}, series : [], yaxis : { tickAmount : 5, show : false, min : 0, max : 100 }, xaxis : { categories : [] } },
    cpu : { colors:['#339BFB' ], title : { text: 'CPU (%)', align : 'left' }, series : [], yaxis : { tickAmount : 5, show : false, min : 0, max : 100 }, xaxis : { categories : [] } },
    workload : { stroke: { width: 0 }, dataLabels: { enabled: true }, plotOptions : {
      legend : { show : false },
      heatmap : {
        radius: 15,
        enableShades: false,
        colorScale: { ranges: [{ from: 0, to: 33, color: '#339BFB', name : "low" }, { from: 34, to: 66, color: '#FFC90E', name : "normal" }, { from: 67, to: 100, color: '#F44336', name : "high" }], }

      }
    }
    , title : { text: 'CPU workload (%)', align : 'left' }, series : [], yaxis : { labels : { show : false }, tickAmount : 5, show : false, min : 0, max : 100 }, xaxis : { show : false, labels : { show : false }, tickAmount : 1, categories : [] } },
  },
  is_testing : false,
  is_allow_system : true,
  is_cron: false, cron: [], ms : 0, alive : false, status: { start : '', percentFile : 0, percentFolder : 0 },
  setting : {
    limit_mode : false,
    limit_cpu : 90, limit_ram : 90, limit_disk : 90,
    resolve_cpu : 0, resolve_ram : 0, resolve_disk : 0,
    backup_type : 0, // 1~3
    backup_type_list : ['Hash'],
    ext_list: [], rule: ['Regex','Hash'], max_filesize: 0, realtime_mode: undefined, backup_mode: undefined, forgery_mode : undefined,
    backup_path_history : [], san_list_history : [],
    white_path : [], white_file : [], schedule : [], backup_path : '', scan_list : [], scan_list_history : [], snapshot : { watching : [], white_path : [], white_file : [] }
  },
});

let exp = c => _.flattenDeep(_.concat([], c.child, _.map(c.child, exp)));

const default_opt = (perPage = 15) => ({
  perPage: perPage, //limit,
  currentPage: 1, //
  totalRows: 0,
  adv : false,
  sk : '', sv : '', skt : '', opt : {}
})

export default {
  props : ['is_one'],
  components: {
    Schedule,
    Bell,
    ResultDetail,
    VueApexCharts,
    cSwitch,
    Language,
    VclFacebook,
    FolderSet,
    Item,
    WhitePath,
    AgentList,
    SettingQuickSetup,
    // VueSpeedometer
    // 'tree': Tree
  },
  data: () => {
    return {
      codes,
      loading : false,
      loading_chart : false,
      scan_status : {
        running : false,
        stopping : false,
      },
      modal_scan_list_history : false,
      // chart
      series: [{
        name: '',
        data: [0, 1, 2, 3, 4]
      },
      ],
      //
      modify_nickname : '',
      modal_upgrade : false,
      modal_modify : false,
      apply_all_server: [],
      // 필요 재정의
      index: 0,
      // signalr : signalr.socket(),
      // 페이징 위함
      so_result : default_opt(),
      so_detect : default_opt(),
      so_isolation : default_opt(10),
      // 데이터 결과
      detect_item : undefined,
      result_item : undefined,
      safe_box : undefined,

      converter : '', // 확장자 변수
      // codes,
      s : { time: '03:00', day: 9, h_opt: codes.WSF_SCHEDULE_i18n }, // 스케줄
      v : {},

      // 설정
      dir: [],
      model : default_model(),
      scan_list : [],
      white_path : [],
      white_file : [],
      path : {},
      // 모달 관련
      result_model : {},
      detect_model : {},
      // th : undefined, // 핑퐁 함수

      result : {}, //즉시 검사 결과 결과
      // 상태 정보
      is_socket : false,

      // 삭제 관련
      apply_confirm_modal: false,
      apply_modal: false,
      del_nickname : '',
      del_confirm : false,
      remove_info : '',
      backup_remove_modal : false,

      // 퀵설정 관련
      quick_setting_status : false,
      is_first : false,

    }
  },
  methods: {
    async system_pattern_manual() {
      if(this.model.alive != true) { return this.$toastr.w("agent is offline") }

      // api 로 요청, 점검 완료시 활성화 안내
      let rs = await api.wsfinder.WSFinder_Call('pattern', 'test.system', { agent_id : this.model.id });
      if(rs.error) { return this.$toastr.e("request testing") }
      this.$toastr.s('Request to agents.');
      this.$parent.$emit('refresh');
      this.model.is_testing = true

    },
    copyText(id) {
      try {
        let container = this.$refs[id]

        this.$copyText(container.textContent, container)
        this.$toastr.i(this.i18n_data['copid'][this.i18n])
      } catch (e) {
        console.log(e)
        this.$toastr.w("copy failed")
      }

    },
    add_scan_list(x) {
      if(_.indexOf(this.scan_list, x.abs_path) > -1) {
        return this.$toastr.w("duplicate")
      }
      this.scan_list.push(x.abs_path)
      let t = _.find(exp({ child: this.dir }), { abs_path : x.abs_path })
      if(t) { t.selected = true }
      // console.log("add_scan_list", x.abs_path)
    },
    add_white_list(x) {
      if(_.indexOf(this.white_path, x.abs_path) > -1) {
        return this.$toastr.w("duplicate")
      }

      if(_.filter(this.scan_list, y => {
        // console.log(x.abs_path.replace(/\\/gm, ''), y.replace(/\\/gm, ''), _.startsWith(x.abs_path.replace(/\\/gm, ''), y.replace(/\\/gm, '')) == false)
        return _.startsWith(x.abs_path.replace(/[\\|\\/]/gm, ''), y.replace(/[\\|\\/]/gm, ''))
      }).length < 1) {
        // 해당 경로는 넣을 수 없음
        return this.$toastr.w('warning', 'It is not included in the folder1')
      }

      this.white_path.push(x.abs_path)
      console.log("add_white_list", x.abs_path)
    },
    add_white_list_file(x) {
      if(_.indexOf(this.white_file, x.abs_path) > -1) {
        return this.$toastr.w("duplicate")
      }

      console.log(x, this.white_file)

      if(_.filter(this.scan_list, y => {
        // console.log(x.abs_path.replace(/\\/gm, ''), y.replace(/\\/gm, ''), _.startsWith(x.abs_path.replace(/\\/gm, ''), y.replace(/\\/gm, '')) == false)
        return _.startsWith(x.abs_path.replace(/[\\|\\/]/gm, ''), y.replace(/[\\|\\/]/gm, ''))
      }).length < 1) {
        // 해당 경로는 넣을 수 없음
        return this.$toastr.w('warning', 'It is not included in the folder2')
      }

      if(this.white_file == undefined) { this.white_file = [] } // 하위 호환
      this.white_file.push(x.abs_path)
      console.log("add_white_list", x.abs_path)
    },
    copy(tag) {
      try {
        var tempElem = document.createElement('textarea');
        tempElem.value =`${tag}`;
        document.body.appendChild(tempElem);
        tempElem.select();
        document.execCommand("copy");
        document.body.removeChild(tempElem);
        this.$toastr.i("agent ticket copied for QNA")
      } catch (e) { console.log(e); this.$toastr.i("copied failed") }
    },
    clear(type='scan_list') {
      switch (type) {
        case 'scan_list': this.scan_list = []; break;
        case 'white_path': this.white_path = []; break;
        case 'white_file': this.white_file = []; break;
      }
      // if(type == 'scan_list') { this.scan_list = [] }
      // else { this.white_path = [], this.white_file = [] }
    },
    // 다른 서버 적용 함수 시작
    async multi_save() { // 설정 저장 // 화이트 패스도 저장
      try{
        // if(!this.model.alive) { return this.$toastr.e('Agent Status Check(ERROR)'); }
        if(!this.model.setting.rule.length) { return this.$toastr.e('Please select an application rule.'); }
        if(this.model.setting.backup_mode == undefined) { return this.$toastr.e('Set backup mode.'); }
        if(this.model.setting.realtime_mode == undefined) { return this.$toastr.e('Set the real-time monitoring mode.'); }
        if(this.model.setting.forgery_mode == undefined) { return this.$toastr.e('Please set the integrity mode.'); }
        if(this.converter && _.isString(this.converter)) { this.model.setting.ext_list = _.map(this.converter.split(','), ext => ext.trim()); }
        if(!this.converter.length) { this.model.setting.ext_list = []; }
        if(this.model.setting.max_filesize == '') { this.model.setting.max_filesize = 0 }
        if(typeof this.model.setting.max_filesize == 'string') { this.model.setting.max_filesize = Number(this.model.setting.max_filesize) }
        let body = { setting : this.model.setting, target : this.apply_all_server.map(r => r.id) }
        let rs = await api.wsfinder.WSFinder_Call('agent', 'update.apply', body);
        if(rs.error) { return this.$toastr.e("update failed") }
        this.$toastr.s('Apply to agents.'); this.$parent.$emit('refresh');

        this.apply_confirm_modal = false
        this.apply_modal = false
      } catch(e) { this.catch_msg(e) }
    },
    multi_remove(index) { this.apply_all_server.length < 2 ? this.apply_all_server = [] : this.apply_all_server.splice(index, 1) },
    multi_one(item) {
      if(item) {
        if(!item) { return 'no have a data' }
        // console.log(item)
        if(item.is_del) {
          this.apply_all_server = this.apply_all_server.map(r => { if (r && r.id != item.id) { return r } }).filter( r => r != null)
        } else {
          this.apply_all_server.push(item)
        }
      }
     },
    multi_all(items) { (items || []).map(r => { r && _.filter(this.apply_all_server, { name : r.name }).length < 1 ? this.apply_all_server.push(r) : '' }) },
    multi_clear() { this.apply_all_server = [], console.log("clear") },
    catch_msg(e) { console.log(e), this.$toastr.e(!e.data ? e : (e.data.message ? e.data.message : e.statusText)) },
    // 다른 서버 적용 함수 끝
    save_rs: function(detect_list) {
      if(!detect_list.length) { this.$toastr.i('No WebShell detected.'); return; }
      let blob = new Blob(_.map(detect_list.split('<br>'), r => r+'\r\n'), {type: "text/plain;charset=utf-8"});
      saveAs(blob, `webshell_list_${moment().format('YYYY_MM_DD')}.txt`);
    },
    folder(){ //폴더 로더
      try{ if(_.isEmpty(this.path)) { this.get_path(''); } } catch(e) { console.debug(e) }
    },
    refresh(){ //테이블 새로고침
      try{ this.$refs && this.$refs._dl.refresh(); this.$refs && this.$refs._rl.refresh(); } catch(e) { this.catch_msg(e) }
    },
    async start_scan(){ //스캔 시작
      try{
        if(this.model.setting && this.model.setting.scan_list.length < 1) { return this.$toastr.e("no have scan folder") }
        if(!this.model.setting.rule || (this.model.setting.rule && this.model.setting.rule.length < 1)) { return this.$toastr.e("no have rule for scan") }

        this.scan_status.running = true;
        this.scan_status.stopping = false

        agent.ws.Request('start', this.model.id)
          // .then(rs => this.response_handler(rs))
        let rs = await api.wsfinder.WSFinder_Call('agent', 'start', { id : this.model.id });
        if(rs.error) { return this.$toastr.e("start failed") }

        this.$toastr.s(this.i18n_data['start'][this.i18n])

      } catch(e) { this.catch_msg(e) }
    },
    async stop_scan() { //스캔 중지
      try{
        this.scan_status.stopping = true
        let rs = await api.wsfinder.WSFinder_Call('agent', 'stop', { id : this.model.id });
        if(rs.error) { return this.$toastr.e("start failed") }

        this.$toastr.s(this.i18n_data['stop'][this.i18n])

        // this.response_handler(await agent.ws.Cmd('stop', this.model.id));
      } catch(e) { this.catch_msg(e) }
    },
    async get_path(path){ //경로 로더
      // try {
        agent.ws.Cmd('path', this.model.id, typeof path == typeof '' ? path.trim() : path.abs_path.trim())
          .then(rs => this.response_handler(rs))
          .catch(e => this.catch_msg(e))
        // ; } catch(e) { this.catch_msg(e) }
    },
    remove_sch(i){ this.model.setting.schedule.splice(i, 1); },//스케줄 지우기
    remove_path(i){ this.model.setting.white_path.splice(i, 1); },// 예외 경로 지우기
    remove_file(i){ this.model.setting.white_file.splice(i, 1); },// 예외 경로 지우기
    add_white_path(x) { // 예외 경로 추가
      this.v.white_path = _.trim(x);
      if (!this.v.white_path) { return; }
      else {
        if(this.model.setting.white_path.indexOf(this.v.white_path) > -1) { return this.$toastr.i('This item already exists'); }
        this.model.setting.white_path.push(this.v.white_path)
        this.v.white_path = [];
      }
    },
    add_white_file(x) { // 예외 경로 추가
      this.v.white_file = _.trim(x);
      if (!this.v.white_file) { return; }
      else {
        if(this.model.setting.white_file.indexOf(this.v.white_file) > -1) { return this.$toastr.i('This item already exists'); }
        this.model.setting.white_file.push(this.v.white_file)
        this.v.white_file = [];
      }
    },
    async save_setting() { // 설정 저장 // 화이트 패스도 저장
      try{
        // if(!this.model.alive) { return this.$toastr.e('Agent Status Check(ERROR)'); }
        if(!this.model.setting.rule.length) { return this.$toastr.e('Please select an application rule first.'); }
        if(this.model.setting.backup_mode == undefined) { return this.$toastr.e('Set backup mode.'); }
        if(this.model.setting.realtime_mode == undefined) { return this.$toastr.e('Set the real-time monitoring mode.'); }
        if(this.model.setting.forgery_mode == undefined) { return this.$toastr.e('Please set the integrity mode.'); }
        if(!this.model.setting.backup_path) { return this.$toastr.e('Please set the Isolation path'); }
        if(this.converter && _.isString(this.converter)) { this.model.setting.ext_list = _.map(this.converter.split(','), ext => ext.trim()); }
        if(!this.converter.length) { this.model.setting.ext_list = []; }
        if(this.model.setting.max_filesize == '') { this.model.setting.max_filesize = 0 }
        if(typeof this.model.setting.max_filesize == 'string') { this.model.setting.max_filesize = Number(this.model.setting.max_filesize) }
        this.model.name = this.model.name.trim()

        // 격리 모드 추가
        this.model.setting.backup_type = this.model.setting.backup_mode ? 1 : 0
        if(this.model.setting.backup_type) {
          if(this.model.setting.backup_mode && (this.model.setting.backup_type_list == undefined || this.model.setting.backup_type_list.length < 1)) {
            return this.$toastr.e('Please select an backup type')
          }

          // 격리 가능은 3개로 hash, url, regex
          if(this.model.setting.backup_type_list.length < 4) {
            // 부분 격리
            this.model.setting.backup_type = 2
          }
        }

        // 제한 알림 부분 추가
        if(this.model.setting.limit_mode == true) {
          if(this.model.setting.resolve_cpu > this.model.setting.limit_cpu || this.model.setting.resolve_ram > this.model.setting.limit_ram || this.model.setting.resolve_disk > this.model.setting.limit_disk) {
            return this.$toastr.e('check alert condition')
          }

          if(this.model.setting.resolve_cpu  == 0 || this.model.setting.limit_cpu == 0 || this.model.setting.resolve_ram == 0 || this.model.setting.limit_ram == 0 || this.model.setting.limit_disk == 0  || this.model.setting.resolve_disk == 0) {
            return this.$toastr.e('alert value is not be ZERO')
          }
        }


        console.log('mod', this.model.setting.backup_mode, 'type', this.model.setting.backup_type, this.model.setting.backup_type_list)


        let rs = await api.wsfinder.WSFinder_Call('agent', 'update', this.model);
        if(rs.error) { return this.$toastr.e("update failed") }
        this.$toastr.s(this.i18n_data['saved'][this.i18n]); this.$emit('refresh');

        let setting = typeof rs.body.setting == typeof '' ? JSON.parse(rs.body.setting) : rs.body.setting

        this.model.setting.backup_path_history = setting.backup_path_history

        // this.lock = true;
      } catch(e) { this.catch_msg(e) }
    },
    info(){ //상태 정보 가지고오기 (핑, 상태값)
      try {
        agent.ws.Cmd("ping", `${this.model.id}`).then(rs => this.response_handler(rs))
        agent.ws.Cmd("status", `${this.model.id}`).then(rs => this.response_handler(rs))
        window['th'] = setTimeout(() => { this.info(); }, 3000 );
      } catch(e) { this.catch_msg(e) }
    },
    async save_box(){ //세이프 박스
      try{ agent.ws.Cmd('list', `${this.model.id}`).then(rs => this.response_handler(rs)); } catch(e) { this.catch_msg(e) }
    },
    async backup(m){ //백업
      try{ agent.ws.Cmd("backup", `${this.model.id}`, m.path).then(rs => this.response_handler(rs)); } catch(e) { this.catch_msg(e) }
    },
    async backup_restore(m){ //백업 되돌리기
      try{ agent.ws.Cmd('restore', `${this.model.id}`, m.hash).then(rs => this.response_handler(rs)); this.save_box() } catch(e) { this.catch_msg(e) }
    },
    async detect_exception(m){
      try {
        if(_.includes(this.model.setting.white_path, m.path)) { this.$toastr.w("It's a path that exists."); return; }
        let d = { id : this.model.id, setting : this.model.setting }
        d.setting.white_path.push(m.path)
        let rs = await api.wsfinder.WSFinder_Call('agent', 'update', d);
        if(rs.error) { return this.$toastr.e("update failed") }
        this.res_msg({ body : rs }, "white file");
      } catch(e) { this.catch_msg(e) }
    },
    async backup_exception(m) {
      try {
        // 중복 검사
        if(_.includes(this.model.setting.white_path, m.path)) { this.$toastr.w("It's a path that exists."); return; }
        let d = { id : this.model.id, setting : this.model.setting }
        d.setting.white_path.push(m.path)
        let rs = await api.wsfinder.WSFinder_Call('agent', 'update', d);
        this.res_msg({ body : rs }, "white file");
      } catch(e) { this.catch_msg(e) }
    },
    async backup_remove(m) {
      try{ agent.ws.Cmd('remove', `${this.model.id}`, m.hash).then(rs => this.response_handler(rs)) } catch(e) { this.catch_msg(e) }
    },
    async backup_download(m){
      try{ agent.ws.Cmd('download', `${this.model.id}`, m.hash).then(rs => this.response_handler(rs)); } catch(e) { this.catch_msg(e) }
    },
    async detect_download(m){
      try{ agent.ws.Cmd('download_raw', `${this.model.id}`, m.path).then(rs => this.response_handler(rs)); } catch(e) { this.catch_msg(e) }
    },
    async detect_select(id = this.model.id){
      try{
        let rs = await api.wsfinder.WSFinder_Call('detect', 'detail', { id : id.id })
        if(rs.error) { this.$toastr.e("load failed") }
        this.detect_model = Object.assign({}, this.detect_model, rs.body,  { description : JSON.parse(rs.body.description) });
        this.$refs.detect_modalRef.show();
      } catch(e) { this.catch_msg(e) }
    },
    async detect_load(id = this.model.id){
      try{
        let rs = await api.wsfinder.WSFinder(
          { target : 'detect', cmd: 'list', offset : (this.so_detect.currentPage - 1) * this.so_detect.perPage, limit : this.so_detect.perPage,
            body : { and : [ { "name" : "agent_id", "value" : id, "op" : "=" } ], sort : [ { "name" : "group_id" }, { "name" : "id", "op" : "desc" } ]}
          }
        )
        if(rs.error) { this.$toastr.e("load failed") }
        this.detect_item = rs.total
        return rs.body;
      } catch(e) { this.catch_msg(e) }
    },
    async result_load(id = this.model.id){
      try{
        let rs = await api.wsfinder.WSFinder(
          { target : 'result', cmd: 'list', offset : (this.so_result.currentPage - 1 ) * this.so_result.perPage, limit : this.so_result.perPage,
            body : { and : [ { "name" : "agent_id", "value" : id, "op" : "=" } ], sort : [ { "name" : "group_id" }, { "name" : "id", "op" : "desc" } ]}
          }
        )
        if(rs.error) { this.$toastr.e("load failed") }
        this.result_item = rs.total
        _.forEach(rs.body, x => {
          let sec = moment(x.created_at).diff(moment(x.scan_time), 'seconds')
          x.scanning_time =  `${Math.floor(sec / 60) < 0 ? 0 : Math.floor(sec / 60)}:${`${sec % 60 < 0 ? 0 : sec % 60}`.padStart(2, '0')}`
        })
        return rs.body;
      } catch (e) { this.$toastr.e(e.data ? e.data.message : e.statusText) }
    },
    async getResult() { return this.result_load(); },
    async getDetect() { return this.detect_load(); },
    async result_select(id = this.model.id){
      try{
        let rs = await api.wsfinder.WSFinder_Call('result', 'detail', {id : id.id})
        if(rs.error) { return this.$toastr.e("result load failed") }
        this.result_model = rs.body;
        this.result_model.detect_list = _.join(this.result_model.detect_list, '<br>'); this.$refs.result_modalRef.show();
      } catch(e) { this.catch_msg(e) }
    },
    async folder_save(){
      if(this.scan_list && !this.scan_list.length){ return this.$toastr.e('Folder Settings Required.');}
      if(this.model.setting.ext_list && _.isString(this.model.setting.ext_list)) { this.model.setting.ext_list = _.map(this.model.setting.ext_list.split(','), ext => ext.trim()); }
      if(!this.model.setting.ext_list.length) { this.model.setting.ext_list = []; }
      try{
        this.model.setting.scan_list = this.scan_list;
        this.model.setting.white_path = this.white_path;
        this.model.setting.white_file = this.white_file;
        let rs = await api.wsfinder.WSFinder_Call('agent', 'update', this.model);
        if(rs.error) { this.$toastr.e("update failed") }

        let setting = typeof rs.body.setting == typeof '' ? JSON.parse(rs.body.setting) : rs.body.setting

        this.model.setting.scan_list_history = setting.scan_list_history

        this.$parent.$emit('refresh'); this.$toastr.s(this.i18n_data['saved'][this.i18n]);
      } catch(e) { this.catch_msg(e) }
    },
    async apply(){
      try {
        let rs = await api.wsfinder.WSFinder_Call('agent', 'update', Object.assign({}, { id : this.model.id, name : this.modify_nickname }));
        if(rs.error) { return this.$toastr.e("agent update failed") }
        this.model.name = this.modify_nickname
        this.$toastr.s(this.i18n_data['saved'][this.i18n]);
      } catch(e) { this.catch_msg(e) }
    },
    async remove() {
      try{
        this.del_nickname = (this.del_nickname || '').trim()
        if(this.model.name.trim() != this.del_nickname) { return this.$toastr.e('Invalid agent name entered');  }
        this.del_nickname = '';
        let rs = await api.wsfinder.WSFinder_Call('agent', 'delete', {id : this.model.id})
        if(rs.error) { return this.$toastr.e("agent delete failed") }
        this.$parent.$emit('refresh'); this.$toastr.s(this.i18n_data['removed'][this.i18n]); this.list();
      } catch(e) { this.catch_msg(e) , this.list() }
    },
    async upgrade() {
      try {
        let rs = await api.wsfinder.WSFinder_Call('agent', 'upgrade', { id : this.model.id });
        if(rs.error) { return this.$toastr.e("start failed") }

        this.$toastr.s(this.i18n_data['upgrade'][this.i18n])

        // agent.ws.Cmd('update', this.model.id).then(rs => this.response_handler(rs))
        // this.$toastr.s('Upgrade request');
      } catch (e) { this.catch_msg(e) }
    },
    list: function() { this.$router.push({ name: 'wsfinder_agent'}); },
    async get(id = this.$route.params.id) {
      this.loading = true;
      console.log('agent.detail.vue', 'load item', id);
      try {
        let rs = await api.wsfinder.WSFinder_Call('agent', 'detail', { id : id })
        let rv = Object.assign({}, rs.body, { setting: rs.body.setting });
        if (rv.setting.schedule == undefined) { rv.setting.schedule = [] }
        if (rv.setting.white_path == undefined) { rv.setting.white_path = [] }
        if (rv.setting.scan_list == undefined) { rv.setting.scan_list = [] }
        if (rv.setting.backup_type_list == undefined) { rv.setting.backup_type_list = [] }

        this.model = Object.assign({}, this.model, rv);

        if(this.model.setting.ext_list.length) { this.converter = _.join(this.model.setting.ext_list, ','); }
        this.scan_list = this.model.setting.scan_list;
        this.white_path = this.model.setting.white_path;
        this.white_file = this.model.setting.white_file;
        this.is_socket = this.model.tag.substring(0, 3) == "ws." ? true : false;

        if(this.model.updated_at == this.model.created_at) { this.quick_setting_status = true; this.is_first = true }

        if(location.hostname == 'localhost') {
          this.index = 2
        }
        this.loading = false;
        this.loading_chart = true
      } catch(e) { this.catch_msg(e) , this.list() }
    },
    res_msg(pl, cmd) {
      if(pl && pl.error) { this.$toastr.e(pl.reason, `${cmd} failed`); return 'error'; }
      else if(cmd == "status" || cmd == "pong" || cmd == "resource") { return cmd; }
      // else { this.$toastr.s(`${cmd} done`); return cmd }
      return cmd;
    },
    async response_handler(m) {
      if((!m.body && !m.cmd && m.cmd != 'list') || m.agent_id != this.model.id) { return;  }
      let pl = m.body;



      try {
        pl = typeof pl == typeof '' ? JSON.parse(pl) : pl;
      } catch  (e) {
        console.log(e)
      }


      switch(this.res_msg(pl, m.cmd)){
        case 'update' :
          console.log('update info', pl)
          if(pl.error) {
            // 업데이트 실패
            this.$toastr.e(pl.reason)
          } else {
            this.$toastr.e(`the agent updated ${pl.version} !!`)
          }
          break;
        case 'resource' :
          console.log('resource info', pl)
          this.$toastr.w(pl)
          break;
        case 'remove' : this.$toastr.i(this.i18n_data['remove'][this.i18n]); this.save_box(); break;
        case 'restore' : this.$toastr.i(this.i18n_data['restore'][this.i18n]); this.save_box(); break;
        case 'backup' : this.$toastr.i(this.i18n_data['backup'][this.i18n]); this.save_box(); break;
        case 'list' :
          this.safe_box = pl
            ? _.map(pl || [], x => { let rs = x.split('\t'); return { hash : rs[0], path : rs[1] , data : moment(Number(rs[0].split('.')[1])) } })
            : [];
          break;

        case 'status' :
          this.loading_chart = false

          this.model.status = pl
          console.log('this.model.status', this.model.status)

          if(!this.model.status) { return console.log('pl', pl, m.cmd) }

          this.model.status.percentFile = this.percent(this.model.status.scan_count, this.model.status.scan_count_left);
          this.model.status.percentFolder = this.percent(this.model.status.scan_folder, this.model.status.scan_folder_left);


          if(this.model.status.percentFile && pl.is_real_time == false) {
            this.scan_status.running = true
          }

          // add chart data
          this.model.status.system_memory_info = this.model.status && this.model.status.system_memory_info && typeof '' == typeof this.model.status.system_memory_info ? JSON.parse(this.model.status.system_memory_info) : this.model.status.system_memory_info
          if(this.model.status.system_memory_info) {
            let value = this.model.status.system_memory_info
            if(this.model.status.system_memory_info.usedPercent) {
              value = this.model.status.system_memory_info.usedPercent
            }

            value = Number(value.toFixed(1))

            if(this.model.chart.memory.series.length < 1) {
              this.model.chart.memory.series = []
              this.model.chart.memory.series.push({ name : '', data : [] })
            }

            if(this.model.chart.memory.series[0].data.length >= 8) {
              this.model.chart.memory.series[0].data.shift()
              this.model.chart.memory.xaxis.categories.shift()
            }

            this.model.chart.memory.series[0].data.push(value)
            this.model.chart.memory.xaxis.categories.push(moment().format('mm:ss'))

            if(value > 33) {
              this.model.chart.memory.colors[0] = this.model.chart.color.WARNING
              if(value > 66) {
                this.model.chart.memory.colors[0] = this.model.chart.color.DANGER
              }
            } else {
              this.model.chart.memory.colors[0] = this.model.chart.color.NORMAL
            }

            this.$refs._chart_memory && this.$refs._chart_memory.updateSeries(this.model.chart.memory.series)

          }

          this.model.status.system_cpu_info = this.model.status && this.model.status.system_cpu_info && typeof '' == typeof this.model.status.system_cpu_info ? JSON.parse(this.model.status.system_cpu_info) : this.model.status.system_cpu_info


          if(this.model.status && this.model.status.system_cpu_info.info && this.model.status.system_cpu_info.info.length > 0 && !this.model.status.system_cpu_name) {
            try {
              this.model.status.system_cpu_info.info = JSON.parse(this.model.status.system_cpu_info.info)
            } catch (e) {
              // console.log(e)
            }

            if(typeof this.model.status.system_cpu_info.info == typeof '') {
              // 개선
              this.model.status.system_cpu_name = this.model.status.system_cpu_info.info
            } else {
              // 하위 호환
              this.model.status.system_cpu_name = this.model.status.system_cpu_info.info[0].modelName
            }

            this.model.chart.workload.title = {
              text: this.model.status.system_cpu_name + ' WorkLoad',
              align: 'left',
              margin: 10,
              offsetX: 0,
              offsetY: 0,
              floating: false,
              style: {
                fontSize:  '14px',
                fontWeight:  'bold',
                // fontFamily:  undefined,
                color:  '#263238'
              },
            }
          }

          if(this.model.status.system_cpu_info && this.model.status.system_cpu_info.usage) {

            if(this.model.chart.cpu.series.length < 1) {
              this.model.chart.cpu.series = []
              this.model.chart.cpu.series.push({
                name : '', data : []
              })
            }
            if(this.model.chart.cpu.series[0].data.length >= 8) {
              this.model.chart.cpu.series[0].data.shift()
              this.model.chart.cpu.xaxis.categories.shift()
            }
            this.model.chart.cpu.series[0].data.push(this.model.status.system_cpu_info.usage)
            this.model.chart.cpu.xaxis.categories.push(moment().format('mm:ss'))

            // cpu 데이터가 있을 경우
            if(this.model.status.system_cpu_info.usages) {
              this.model.status.system_cpu_info.usages = _.map(this.model.status.system_cpu_info.usages, x => Number(x.toFixed(1)))
              // console.log(this.model.status.system_cpu_info.usages)

              // this.model.status.system_cpu_info.usage = (_.sum(this.model.status.system_cpu_info.usages, x => Number(x)) / this.model.status.system_cpu_info.usages.length).toFixed(1)

              if(Number(this.model.status.system_cpu_info.usage) > 33) {
                this.model.chart.cpu.colors[0] = this.model.chart.color.WARNING
                if(Number(this.model.status.system_cpu_info.usage) > 66) {
                  this.model.chart.cpu.colors[0] = this.model.chart.color.DANGER
                }
              } else {
                this.model.chart.cpu.colors[0] = this.model.chart.color.NORMAL
              }

              // heatmap chart 시작
              if(this.model.chart.workload.series.length < 1) {
                this.model.chart.workload.series = []
                // this.model.chart.workload.series.push({ name : '1', data : [], categories : [] })
                // this.model.chart.workload.series.push({ name : '2', data : [], categories : [] })
                this.model.chart.workload.series.push({ name : '', data : [], categories : [] })
              }

              // this.model.chart.cpu.series[0].data[this.model.chart.cpu.series[0].data.length - 1] = (_.sum(this.model.status.system_cpu_info.usages) / this.model.status.system_cpu_info.usages.length).toFixed(2)

              // this.model.chart.workload.series[2] = JSON.parse(JSON.stringify(this.model.chart.workload.series[1]))
              // this.model.chart.workload.series[1] = JSON.parse(JSON.stringify(this.model.chart.workload.series[0]))
              this.model.chart.workload.series[0].data = this.model.status.system_cpu_info.usages


              // let thread = Math.sqrt(this.model.status.system_cpu_info.usages.length) * 2
              // let count = (this.model.status.system_cpu_info.usages.length / thread) + (this.model.status.system_cpu_info.usages.length % thread > 0 ? 1 : 0)
              // for (let i = 0; i < count; i++) {
              //   this.model.chart.workload.series.push({ name : '', data : [], categories : [] })
              //   let max = (i + 1) * thread
              //   max = max > this.model.status.system_cpu_info.usages.length ? this.model.status.system_cpu_info.usages.length : max
              //   console.log('max', max)
              //   this.model.chart.workload.series[this.model.chart.workload.series.length -1].data = this.model.status.system_cpu_info.usages.slice(i * thread, max)

              //   console.log('line', i, this.model.chart.workload.series[this.model.chart.workload.series.length -1].data, 'start', i * thread > 0 ? (i * thread) -1 :  0, 'end', max -1)
              // }
              // console.log(count, this.model.status.system_cpu_info.usages.length)

              // dev
              // this.model.chart.workload.series.push({ name : '1', data : [], categories : [] })
              // this.model.chart.workload.series.push({ name : '2', data : [], categories : [] })
              // this.model.chart.workload.series[0].data = this.model.status.system_cpu_info.usages
              if(this.$refs._chart_workload) {
                // refresh
                // console.log('reload workload')
                this.$refs._chart_workload.updateSeries(this.model.chart.workload.series)
              }
            }

            // cpu 차트 컬러 조정
            if(Number(this.model.status.system_cpu_info.usage) > 33) {
              this.model.chart.cpu.colors[0] = this.model.chart.color.WARNING
              if(Number(this.model.status.system_cpu_info.usage) > 66) {
                this.model.chart.cpu.colors[0] = this.model.chart.color.DANGER
              }
            } else {
              this.model.chart.cpu.colors[0] = this.model.chart.color.NORMAL
            }

            this.$refs._chart_cpu && this.$refs._chart_cpu.updateSeries(this.model.chart.cpu.series)
          }

          break;

        case 'path':
          _.forEach(exp(pl), c => { c.open = false; c.selected = _.includes(this.scan_list, c.abs_path); });
          if(pl.abs_path == '') { this.dir = pl.child; }
          else {
            let t = _.find(exp({ child: this.dir }), { abs_path : pl.abs_path });
            this.ff = pl.abs_path;
            t.child = pl.child;
          }
          break;

        case 'download':
          if(pl.content.length == 0) { this.$toastr.w('Empty File', 'Error'); return; }
          saveAs(new Blob([forge.util.decode64(pl.content)], { type: "text/plain;charset=utf-8"}), pl.name);
          break;

        case 'pong' :
          this.model =  _.assign(this.model, { ms : Math.abs(new Date().getTime() - pl), alive : true });
          break;

        case 'result':
        case 'result.bulk':
          console.log('get', pl)
          this.model.status.percentFile = 100;
          this.result = pl;
          this.result.created_at = moment().format()
          this.result.agent = {
            ip_addr_private : this.model.ip_addr_private,
            ip_addr_public : this.model.ip_addr_public,
            name : this.model.name,
            host : this.model.host,
            // is_allow_system : this.model.is_allow_system
          }

          console.log('this.result.setting', this.result.setting)

          this.result.setting = typeof this.result.setting == typeof '' ? JSON.parse(this.result.setting) : this.result.setting
          this.result.setting.is_allow_system =  this.model.is_allow_system
          this.result.setting = JSON.stringify(this.result.setting)

          // this.result.detect_list = _.join(this.result.detect_list, '<br>');
          // this.result.sec = moment(this.result.created_at).diff(moment(this.result.scan_time), 'seconds')
          // this.result.scanning_time =  `${Math.floor(this.result.sec / 60) < 0 ? 0 : Math.floor(this.result.sec / 60)}:${`${this.result.sec % 60 < 0 ? 0 : this.result.sec % 60}`.padStart(2, '0')}`

          if(this.result.detect_count != 0) { this.$toastr.e(this.i18n_data['findout'][this.i18n]); }
          this.active = true;
          if(this.$refs  && this.$refs.scan_modalRef) {
            this.$refs.scan_modalRef.show();
          } else {
            // 모달이 없어 알림만
            this.$toastr.i('WSFinder Agent scan complete');
          }

          if(this.scan_status.stopping) { this.$toastr.i(this.i18n_data['stopped'][this.i18n]) }
          this.scan_status.stopping = false
          this.scan_status.running = false;
          this.model.status.running = false

          this.$refs._dl && this.$refs._dl.refresh()

          this.$refs._rl && this.$refs._rl.refresh()
          break;
        case 'error' :
          break;
      }
    },
    remove_select(type, s) {
      console.log(type, s)
      if(type == 'scan_list') {
        // 예외 경로에 있을 경우 삭제 불가를 안내 해야 함
        if(_.filter(this.white_path, y => _.startsWith(y.replace(/\\/gm, ''), s.replace(/\\/gm, '')) == true).length > 0) {
          // console.log(this.white_path, s)
          // 해당 경로는 삭제할 수 없음
          return this.$toastr.w('warning', 'first, remove white path or file setting')
        }
        this.scan_list = _.filter(this.scan_list, x => x != s);
      }

      if(type == 'white_path') {
        this.white_path = _.filter(this.white_path, x=> x != s);
      }
      if(type == 'white_file') {
        this.white_file = _.filter(this.white_file, x=> x != s);
      }

      this.folder();
    },
    percent(i1, i2) { return i1 == 0 ? 0 : Number(((i1 / i2) * 100).toFixed(2) || 0) },
    is_latest() {
      try {
        // console.log(Number(this.model.version.replace(/[v/c]/i, '')), Number(config.version), Number(this.model.version.replace(/[v/c]/i, '')) < Number(config.version))
        if(this.model.version && Number(this.model.version.replace(/[v/c]/i, '')) >= Number(config.version)) {
          return true
        }
        return  false
      } catch (e) { console.log(e); return true; }
    },
  },
  watch: {
    '$route' (to, from) { this.get(to.params.id); console.debug(from) },
    selected_path(e) {
      if(e) { console.debug("load path") }
      let map = this.selected_path; // items, exsits in tree
      const exclude = _.map(_.filter(exp({ child: this.dir }), { selected: false }), 'abs_path');
      const filter  = _.filter(this.scan_list, x => _.includes(exclude, x));
      this.scan_list = _.uniq(_.flatten(_.concat(map, _.filter(this.scan_list, x => !_.includes(filter, x)))).sort());
    }
  },
  computed: {
    i18n_data() { return _i18n_data; },
    // ramStatus() { return this.model.status && this.model.status.system_memory_info ? Number(JSON.parse(this.model.status.system_memory_info ? this.model.status.system_memory_info : '{}').usedPercent.toFixed(0)) : 0 },
    // cpuStatus() { return this.model.status && this.model.status.system_cpu_info ? JSON.parse(this.model.status.system_cpu_info).usage * 10 : 0 },
    disckStatus() { return this.model.status && this.model.status.system_disk_info ? _.filter(( typeof '' == typeof this.model.status.system_disk_info ? JSON.parse(this.model.status.system_disk_info) :  this.model.status.system_disk_info).info, x => x.mountpoint && x.percent) : [] },
    runStatus() { return this.model && this.model.status && this.model.status.running == true && this.model.status.is_real_time == false },
    detect_fields() { return i18n_detect[this.i18n]; },
    result_fields() { return i18n_result[this.i18n]; },
    safe_fields() { return i18n_safe[this.i18n]; },
    white_fields() { return i18n_white[this.i18n]; },
    selected_path() { return _.map(_.filter(exp({ child: this.dir }), 'selected'), 'abs_path'); },
  },
  created: function() { console.log('agent.detail.vue', 'created'); },
  destroyed: function() {
    // signalr.off('wsfinder_response', this.response_handler);
    console.log('agent.detail.vue', 'destroyed');
    if(window['th']) { clearTimeout(window['th']); window['th'] = undefined; }
  },
  mounted: function() {
    if(window['th']) { clearTimeout(window['th']); window['th'] = undefined; }
    console.log('agent.detail.vue', 'mounted');
    signalr.subscribe('wsfinder_response', this.response_handler);
    console.log('start ping&status')
    this.info();
    this.get(this.$route.params.id);
  }
}
const i18n_detect = {
  EN: [
    { key: 'created_at', label: 'Detect Time' , thStyle: 'width: 10%'},
    { key: 'type', label: 'Type' },
    { key: 'path', label: 'Path'  },
    { key: 'select', label: 'Check' , thStyle: 'width: 30%'}
  ],
  KO: [
    { key: 'created_at', label: '탐지시각' , thStyle: 'width: 10%'},
    { key: 'type', label: '타입', },
    { key: 'path', label: '경로',  },
    { key: 'select', label: '상세' , thStyle: 'width: 30%'}
  ]
}
const i18n_result = {
  EN: [
    { key: 'scan_time', label: 'Check Time', thStyle: 'width: 15%'},
    { key: 'scan_folder', label: 'Check Folder', },
    { key: 'scan_count', label: 'Check File', },
    { key: 'detect_count', label: 'Detect Result', },
    { key: 'select', label: 'Check' , thStyle: 'width: 10%'}
  ],
  KO: [
    { key: 'scan_time', label: '점검시간', thStyle: 'width: 15%'},
    { key: 'scan_folder', label: '점검폴더', },
    { key: 'scan_count', label: '점검파일', },
    { key: 'detect_count', label: '탐지결과', },
    { key: 'select', label: '상세' , thStyle: 'width: 10%'}
  ]
}
const i18n_safe = {
  EN: [
    { key: 'path', label: 'Path' , thStyle: 'width: 30%', sortable :false},
    { key: 'hash', label: 'MD5', thStyle: 'width: 20%', sortable :false},
    { key: 'created_at', label: 'Detect Time' , thStyle: 'width: 10%', sortable :false},
    { key: 'select', label: 'Command' , thStyle: 'width: 20%', sortable :false}
  ],
  KO: [
    { key: 'path', label: '경로' , thStyle: 'width: 30%', sortable :false},
    { key: 'hash', label: 'MD5', thStyle: 'width: 20%', sortable :false},
    { key: 'created_at', label: '탐지시간' , thStyle: 'width: 10%', sortable :false},
    { key: 'select', label: '명령' , thStyle: 'width: 20%', sortable :false}
  ]
}
const i18n_white = {
  EN: [
    { key: 'id', label: 'id' , thStyle: 'width: 30%'},
    { key: 'path', label: 'Path' , thStyle: 'width: 30%'},
    { key: 'select', label: 'Command' , thStyle: 'width: 20%'}
  ],
  KO: [
    { key: 'id', label: 'id' , thStyle: 'width: 30%'},
    { key: 'path', label: '경로' , thStyle: 'width: 30%'},
    { key: 'select', label: '명령' , thStyle: 'width: 20%'}
  ]
}
